module.exports = __webpack_public_path__ + "static/img/16.dc94d2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/16.png
// module id = XYsf
// module chunks = 4